import { render, staticRenderFns } from "./SubmissionManagement.vue?vue&type=template&id=8db1b266&scoped=true"
import script from "./SubmissionManagement.vue?vue&type=script&lang=js"
export * from "./SubmissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db1b266",
  null
  
)

export default component.exports